import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { ResidentUpdatesPage } from "@/components/app/portal/pages/resident-updates-page";

export const Route = createFileRoute("/resident-portal/updates")({
  head: () => ({ meta: [{ title: "Updates | People AI" }] }),
  component: ResidentUpdates,
});

function ResidentUpdates() {
  return (
    <OwnResident>
      {(own) => <ResidentUpdatesPage kind="resident" residentId={own.residentId} />}
    </OwnResident>
  );
}
